export default __webpack_public_path__ + "static/media/scripting.a9bf05d3.png";